import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { Document } from '@vi-iot/client';

import { AppState } from '../app.state';

import { DocumentsState } from './documents.state';

export namespace DocumentsSelectors {
  const DOCUMENTS_KEY = 'termsOfUse';
  const DATA_USAGE_AGREEMENT_KEY = 'dataUseAgreement';

  export const documentsState = (state: AppState): DocumentsState => state.documents;

  export function selectState(): MemoizedSelector<
    AppState,
    DocumentsState,
    DefaultProjectorFn<DocumentsState>
  > {
    return createSelector(documentsState, (state: DocumentsState) => state);
  }

  export function selectUpdatedDocuments(): MemoizedSelector<
    AppState,
    Document[],
    DefaultProjectorFn<Document[]>
  > {
    return createSelector(documentsState, (state: DocumentsState) => state.documentsUpdated);
  }

  export function selectTermsOfUseDocument(): MemoizedSelector<
    AppState,
    Document,
    DefaultProjectorFn<Document>
  > {
    return createSelector(documentsState, (state: DocumentsState) =>
      state.documents.find(
        (entry: Document) => entry.documentType.toLowerCase() === DOCUMENTS_KEY.toLowerCase()
      )
    );
  }

  export function selectDataUsageAgreementDocument(): MemoizedSelector<
    AppState,
    Document,
    DefaultProjectorFn<Document>
  > {
    return createSelector(documentsState, (state: DocumentsState) =>
      state.documents.find(
        (entry: Document) =>
          entry.documentType.toLowerCase() === DATA_USAGE_AGREEMENT_KEY.toLowerCase()
      )
    );
  }

  export function selectDocuments(): MemoizedSelector<
    AppState,
    Document[],
    DefaultProjectorFn<Document[]>
  > {
    return createSelector(documentsState, (state: DocumentsState) => state.documents);
  }

  export function selectXotaAgreementStatus(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(documentsState, (state: DocumentsState) => state.xotaMode);
  }

  export function selectXotaAgreementLoading(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(documentsState, (state: DocumentsState) => state.xotaLoading);
  }
}
